import { DollarSign } from 'lucide-react';
import CurrencySelector from './CurrencySelector';
import { useTranslation } from 'react-i18next';

export const CurrencySection = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <DollarSign size={20} className="text-gray-500 mr-2" />
          <span className="text-base font-medium text-gray-900">{t('components.currencySection.title')}</span>
        </div>
      </div>
      <CurrencySelector />
    </div>
  );
};

export default CurrencySection; 